import React from "react";
import { useUscOptionalLabel } from "../../../../../utils/labels";
import { useUscSelector } from "../../../../../redux/store";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";

const UscVehicleDisclaimers = (): JSX.Element | null => {
    const result = useUscSelector((state) => state.vehicle.result);
    const externalPriceHasError = useUscSelector((state) => state.externalPrice.failed && state.externalPrice.show);
    const vehicleAggregationsEnabled = useUscSelector((state) => state.uscSettings.enableVehicleAggregations);

    const externalPriceErrorLabel = useUscOptionalLabel("uscBasketTotalPriceErrorDisclaimer");
    const hubDisclaimerLabel = useUscOptionalLabel("uscBasketHubDisclaimer", {
        model: result?.product.model,
    });

    if (!result) return null;

    return (
        <>
            {externalPriceHasError && !!externalPriceErrorLabel && (
                <Text tag="div" variant="body-small-book">
                    {externalPriceErrorLabel}
                </Text>
            )}

            {result?.isHubCar && hubDisclaimerLabel && !vehicleAggregationsEnabled && (
                <Text tag="div" variant="body-book" spacing={{ mt: "spacing-2", mb: "spacing-1" }}>
                    {hubDisclaimerLabel}
                </Text>
            )}
        </>
    );
};

export default UscVehicleDisclaimers;
